import { useBackendApi } from './backendApi';
import { useEventsPublisher } from 'event-bus';

export interface TeamPreferences {
  enableNewWysiwygStyles: boolean;
}

export const TEAM_PREFERENCES_UPDATED = 'TEAM_PREFERENCES_UPDATED';

export function useTeamPreferencesService() {
  const backendApi = useBackendApi();
  const eventsPublisher = useEventsPublisher();

  const getTeamPreferences = async (): Promise<TeamPreferences> => {
    return await backendApi.get('/teampreferences') as TeamPreferences;
  };

  const saveTeamPreferences = async (data: TeamPreferences): Promise<TeamPreferences> => {
    const response = await backendApi.post('/teampreferences', data) as TeamPreferences;
    eventsPublisher.publish(TEAM_PREFERENCES_UPDATED, {});
    return response;
  };

  return {
    getTeamPreferences,
    saveTeamPreferences,
  };
}
